import { faShareSquare } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/shared/Button.styled';
import { useI18n } from 'hooks/useI18n';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import {
  StyledHero,
  StyledHeroContainer,
  StyledHeroCta,
  StyledHeroTitle
} from './StateOfTheSectorHero.styled';

const ShareModal = dynamic(() => import('components/shared/ShareModal'), {
  ssr: false
});

const StateOfTheSectorHero: React.FC = () => {
  const { locale } = useRouter();
  const { t } = useI18n('state-of-the-sector');

  const [isShareModalOpened, setIsShareModalOpened] = useState(false);

  return (
    <StyledHero>
      <StyledHeroContainer>
        <StyledHeroTitle>
          <span>{t('hero.pre-title')}</span>
          {t('hero.title')}
        </StyledHeroTitle>
        <p>{t('hero.desc')}</p>

        <StyledHeroCta>
          <Button
            variant="brandTalent"
            type="button"
            sizes="sm"
            onClick={() => setIsShareModalOpened(true)}
          >
            <FontAwesomeIcon icon={faShareSquare} />
            <span>{t('hero.cta')}</span>
          </Button>
        </StyledHeroCta>
      </StyledHeroContainer>

      {isShareModalOpened && (
        <ShareModal
          isOpened={isShareModalOpened}
          close={() => setIsShareModalOpened(false)}
          url={`${window.location.origin}/${locale}${getAppUrl(
            APP_URLS.mantechcar25,
            locale
          )}`}
          emailSubject={t('share-modal.email-subject')}
          twitterMessage={t('share-modal.text')}
          telegramMessage={t('share-modal.text')}
          whatsappMessage={t('share-modal.text')}
          emailMessage={t('share-modal.email-text')}
        />
      )}
    </StyledHero>
  );
};

export default StateOfTheSectorHero;
